import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { EntidadesProductiva } from './entity-entidades-productiva.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityEntidadesProductivaAdapter: EntityAdapter<EntidadesProductiva> =
  createEntityAdapter<EntidadesProductiva>({
    selectId: (model) => model.id,
    sortComparer: (a: EntidadesProductiva, b: EntidadesProductiva): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityEntidadesProductivaState
  extends EntityState<EntidadesProductiva> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityEntidadesProductivaState =
  entityEntidadesProductivaAdapter.getInitialState({
    isLoading: false,
    error: null
  });
